import React, { ReactElement, useCallback } from 'react';
import styled from 'styled-components';

interface Props {
  grid: Array<Array<boolean>>;
  hoverIndexes?: Array<Array<number>>;
  onCellAction?: (action: boolean, rowId: number, colId: number) => void;
  numbered?: boolean;
  cellSize?: number;
}

const Grid = (props: Props): ReactElement => {
  const grid = props.grid;
  const hoverIndexes = props.hoverIndexes;
  const numbered = props.numbered || false;
  const cellSize = props.cellSize || 12;

  const onCellAction =
    props.onCellAction ||
    ((): void => {
      return;
    });
  const numOfCols = grid && grid[0] ? grid[0].length : 0;
  const numOfRows = grid ? grid.length : 0;

  const getCellColor = useCallback(
    (rowId: number, colId: number) => {
      if (
        hoverIndexes &&
        hoverIndexes[rowId] &&
        hoverIndexes[rowId].includes(colId)
      )
        return 'greenyellow';

      return grid[rowId][colId] ? 'black' : 'white';
    },
    [grid, hoverIndexes],
  );

  return (
    <BoardContainer
      style={{
        gridTemplateColumns: `repeat(${
          numOfCols + (numbered ? 1 : 0)
        }, ${cellSize}px)`,
        gridTemplateRows: `repeat(${numOfRows}, ${cellSize}px)`,
      }}
    >
      {numbered && (
        <>
          <div />
          {Array.from({ length: grid[0]?.length }, (_, k) => k + 1).map(i => (
            <div style={{ fontSize: '0.1em', textAlign: 'center' }}>{i}</div>
          ))}
        </>
      )}

      {grid.map((row, rowId) => (
        <>
          {numbered && (
            <div
              style={{
                fontSize: '0.1em',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                height: '15px',
                alignItems: 'center',
              }}
            >
              {rowId + 1}
            </div>
          )}
          {row.map((_col, colId) => (
            <div
              key={`${rowId}-${colId}`}
              onClick={(): void => onCellAction(true, rowId, colId)}
              onMouseOver={(): void => onCellAction(false, rowId, colId)}
              style={{
                width: cellSize,
                height: cellSize,
                backgroundColor: getCellColor(rowId, colId),
                border: '.5px solid darkgray',
              }}
            />
          ))}
        </>
      ))}
    </BoardContainer>
  );
};

const BoardContainer = styled.div`
  display: grid;
`;

export default Grid;
